<mat-toolbar>
  <mat-toolbar-row>
    <span class="example-spacer"></span>
    <button mat-icon-button class="example-icon" (click)="toggle()" position="end">
      <mat-icon>menu</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>